import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useStyles } from '../adminStyles';
import EmployeeList from './components/EmployeeList';
import ContractorList from './components/ContractorList';
import { EMPLOYEE_TYPE } from '../../../redux/constants';
import { getBillingList, saveBillingList } from '../../../redux/billing/billingActions';
import { Grid, FormControl, Select, MenuItem, TextField } from '@material-ui/core';

const Billing = () => {
  document.title = 'Sciata Billing';

  const { inputMobile, selectEmpty, gridElLeft } = useStyles();

  const dispatch = useDispatch();
  const billingList = useSelector(state => state.billing.billingList || []);

  const [employeeRows, setEmployeeRows] = useState([]);
  const [contractorRows, setContractorRows] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [empType, setEmpType] = useState('fulltime');

  const setTheSearchTerm = e => setSearchTerm(e.target.value);
  const bindBilling = () => dispatch(getBillingList());

  useEffect(() => {
    bindBilling();
  }, []);

  useEffect(() => {
    let _employees = [];
    let _contractors = [];
    billingList.map(_user => {
      if (_user.employeeType === EMPLOYEE_TYPE.Fulltime) {
        _employees.push({
          ..._user,
          name: (_user.employeeLName || '') + ' ' + (_user.employeeFName || ''),
        });
      }
      if (_user.employeeType === EMPLOYEE_TYPE.Contractor) {
        _contractors.push({
          ..._user,
          name: (_user.employeeLName || '') + ' ' + (_user.employeeFName || ''),
        });
      }
    });
    setEmployeeRows(
      _employees.sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1))
    );
    setContractorRows(
      _contractors.sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1))
    );
  }, [billingList]);

  const saveRecords = async (e, type) => {
    let _respData = [];

    if (type === EMPLOYEE_TYPE.Fulltime) {
      employeeRows.map(item => {
        if (item.projects.length > 0) {
          _respData = _respData.concat(item.projects);
        }
      });
    } else if (type === EMPLOYEE_TYPE.Contractor) {
      contractorRows.map(item => {
        if (item.projects.length > 0) {
          _respData = _respData.concat(item.projects);
        }
      });
    } else {
      _respData = [];
    }
    if (_respData.length > 0) {
      let res = await dispatch(saveBillingList(_respData));
      if (res) {
        bindBilling();
      }
    }
  };

  return (
    <>
      <h1>Billing</h1>
      <Grid container justify='center' alignItems='center'>
        <Grid item xs={12} md={4} className={gridElLeft}>
          <TextField
            type='search'
            label='Search Users'
            className={inputMobile}
            variant='outlined'
            value={searchTerm}
            onChange={setTheSearchTerm}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <FormControl className={inputMobile}>
            {/* <InputLabel shrink id="demo-simple-select-filled-label">
                            Type
                        </InputLabel> */}
            <Select
              labelId='demo-simple-select-filled-label'
              variant='outlined'
              className={selectEmpty}
              value={empType}
              onChange={e => {
                setEmpType(e.target.value);
              }}
            >
              {Object.keys(EMPLOYEE_TYPE).map(item => {
                return <MenuItem value={EMPLOYEE_TYPE[item]}>{item}</MenuItem>;
              })}
            </Select>
          </FormControl>
        </Grid>
        <Grid md={4} />
        <Grid container item xs={12}>
          {empType === 'fulltime' ? (
            <>
              <EmployeeList
                data={employeeRows}
                onUpdateBilling_Cost={(index, projects) => {
                  let _employeeRows = employeeRows.slice();
                  _employeeRows[index].projects = projects;
                  setEmployeeRows(_employeeRows);
                }}
                bindBilling={bindBilling}
                saveRecords={saveRecords}
                employeeType={EMPLOYEE_TYPE}
                searchTerm={searchTerm}
              />
            </>
          ) : (
            <>
              <ContractorList
                data={contractorRows}
                onUpdateBilling_Cost={(index, projects) => {
                  let _contractorRows = contractorRows.slice();
                  _contractorRows[index].projects = projects;
                  setContractorRows(_contractorRows);
                }}
                bindBilling={bindBilling}
                saveRecords={saveRecords}
                employeeType={EMPLOYEE_TYPE}
                searchTerm={searchTerm}
              />
            </>
          )}
        </Grid>
      </Grid>
    </>
  );
};
export default Billing;
